import { render, staticRenderFns } from "./FeedContentCommentForm.vue?vue&type=template&id=3601cccd&"
import script from "./FeedContentCommentForm.vue?vue&type=script&lang=ts&"
export * from "./FeedContentCommentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports